module.exports = __webpack_public_path__ + "static/media/sport1.3ed68011.jpg";